const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3FF"
    },
    d: "M401.655,185.379c-4.361,0-8.641,0.32-12.87,0.811c-25.13-47.699-75.125-80.259-132.786-80.259 s-107.656,32.561-132.786,80.259c-4.228-0.491-8.509-0.811-12.87-0.811C49.402,185.379,0,234.782,0,295.724 s49.402,110.345,110.345,110.345c25.109,0,266.201,0,291.31,0c60.942,0,110.345-49.402,110.345-110.345 S462.598,185.379,401.655,185.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M379.586,370.759H192.994c-60.682,0-112.422-47.631-113.527-108.302 c-0.543-29.79,10.816-56.856,29.519-77.009C47.842,186.194-1.346,236.609,0.029,298.244 c1.351,60.561,53.359,107.825,113.935,107.825h265.622c9.751,0,17.655-7.904,17.655-17.655l0,0 C397.241,378.663,389.337,370.759,379.586,370.759z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DD7FF"
    },
    d: "M352.733,203.043c-2.914,0-5.759-1.44-7.439-4.07c-19.604-30.621-52.983-48.905-89.293-48.905 c-11.147,0-22.112,1.716-32.595,5.103c-4.664,1.508-9.612-1.043-11.112-5.681c-1.5-4.638,1.043-9.612,5.681-11.112 c12.242-3.958,25.035-5.966,38.026-5.966c42.354,0,81.293,21.327,104.156,57.043c2.63,4.104,1.431,9.569-2.673,12.19 C356.009,202.595,354.362,203.043,352.733,203.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DD7FF"
    },
    d: "M423.742,232.819c-0.853,0-1.732-0.12-2.595-0.388c-5.043-1.551-10.284-2.492-15.586-2.802 c-4.871-0.276-8.586-4.448-8.301-9.319c0.276-4.871,4.543-8.5,9.319-8.301c6.716,0.388,13.362,1.578,19.758,3.543 c4.655,1.431,7.276,6.37,5.845,11.034C431.009,230.379,427.518,232.819,423.742,232.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DD7FF"
    },
    d: "M476.69,304.552c-4.879,0-8.828-3.948-8.828-8.828c0-19.457-8.5-37.836-23.328-50.449 c-3.715-3.155-4.163-8.724-1.009-12.439c3.164-3.742,8.75-4.156,12.439-1.009c18.785,15.965,29.553,39.258,29.553,63.896 C485.517,300.604,481.569,304.552,476.69,304.552z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M229.517,366.354c-1.155,0-2.327-0.181-3.491-0.569c-5.775-1.922-8.905-8.172-6.974-13.956 l52.966-158.897c1.913-5.775,8.129-8.922,13.956-6.974c5.775,1.922,8.905,8.172,6.974,13.956L239.982,358.81 C238.449,363.431,234.138,366.354,229.517,366.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M194.207,339.871c-2.828,0-5.646-1.078-7.801-3.233l-52.966-52.966c-4.31-4.31-4.31-11.293,0-15.604 l52.966-52.966c4.31-4.31,11.293-4.31,15.604,0s4.31,11.293,0,15.604l-45.164,45.164l45.164,45.164c4.31,4.31,4.31,11.293,0,15.604 C199.853,338.793,197.035,339.871,194.207,339.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.793,339.871c-2.828,0-5.646-1.078-7.801-3.233c-4.31-4.31-4.31-11.293,0-15.604l45.164-45.164 l-45.164-45.164c-4.31-4.31-4.31-11.293,0-15.604c4.31-4.311,11.293-4.31,15.604,0l52.966,52.966c4.31,4.31,4.31,11.293,0,15.604 l-52.966,52.966C323.439,338.793,320.621,339.871,317.793,339.871z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.d0a8ab7d1ea485dc6fe79e0c78cffdaf.svg";
export { ForwardRef as ReactComponent };